import { styled, Typography } from '@material-ui/core';

export const Caps = styled(Typography)({
    textTransform: 'uppercase'
});
